import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import arrowForward from "../../assets/icons/arrow_forward_ios_dark_20.svg";
import arrowBack from "../../assets/icons/arrow_back_ios_dark_20.svg";
import { handlePagination } from "../../Util";

type Props = {
    totalCount : number;
    listCount  : number;
    handlePage : (page: number) => void;
    page       : number;
}

const Pagination:React.FC<Props> = ({totalCount, listCount, handlePage, page}) => {
    const [paginationList, setPaginationList] = useState<any>([]);
    const [currentPages, setCurrentPages] = useState<number[]>([]);
    const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
    const [nowPage, setNowPage] = useState<number>(1); // 현재 페이지 css 표시용

    useEffect(() => {
        if(totalCount !== 0) {
            let list = handlePagination(totalCount, listCount);
            setPaginationList(list);
            setCurrentPages(list[currentPageIndex]);
        } else if (totalCount === 0) {
            setPaginationList([]);
            setCurrentPages([]);
        }
    }, [totalCount, listCount, currentPageIndex]);

    useEffect(() => {
        setNowPage(page);
    }, [page]);

    return (
        <S.PaginationBox className="mt-5">
            <div className="page-btn-box">
                {currentPageIndex >= 1 &&
                    (<button className={`mr-2 ${!currentPageIndex ? "cursor-default" : ""}`} onClick={() => {
                        if(currentPageIndex < 1) return;
                        setCurrentPageIndex(currentPageIndex-1);
                        const prevPage = paginationList[currentPageIndex-1][9];
                        handlePage(prevPage);
                        setNowPage(prevPage);
                    }}>
                        <img src={arrowBack} alt="" />
                    </button>)
                }
                {currentPages.map((tmp, idx) =>
                        <div onClick={() => {
                            handlePage(tmp);
                            setNowPage(tmp);
                        }} className={`mx-1 px-[1px] pt-[3px] flex justify-center ${nowPage === tmp ? "text-mainBlack cursor-default" : "text-middleGray02 cursor-pointer"}`} key={idx}>{tmp}</div>
                    )
                }
                {(paginationList.length > currentPageIndex+1) &&
                    (<button className={`ml-2 ${currentPageIndex === paginationList.length-1 ? "cursor-default" : ""}`} onClick={() => {
                        if(paginationList.length-1 > currentPageIndex) {
                            setCurrentPageIndex(currentPageIndex+1);
                            const nextPage = paginationList[currentPageIndex+1][0];
                            handlePage(nextPage);
                            setNowPage(nextPage);
                        }
                    }}>
                        <img src={arrowForward} alt="" />
                    </button>)
                }
            </div>
        </S.PaginationBox>
    )
};

export default Pagination;